const baseUrl = process.env.REACT_APP_SIE_APP_PROXY_BASE_URL;
const TOKEN_KEY = "Bearer";

export const changeStateGraduate = async (userToken: string, bodyRequest?: object) => {
    try {
        const response = await fetch(
            `${baseUrl}/graduate/state`,
            {
                method: 'POST',

                body: JSON.stringify(bodyRequest),
                headers:{
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "sie_token": userToken
                }
            }
        )
        if(response.status === 200){
            return response;
        }
    } catch (error) {
        return error
    }
}

export const changeStateCompany = async (userToken: string, bodyRequest?: object) => {
    try {
        const response = await fetch(
            `${baseUrl}/company/state`,
            {
                method: 'POST',
                body: JSON.stringify(bodyRequest),
                headers:{
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "sie_token": userToken
                }
            }
        )
        if(response.status === 200){
            return response;
        }
    } catch (error) {
        return error
    }
}

export const changeStateLaboralOffer = async (bodyRequest?: object) => {
    let token = "";
    if (sessionStorage.getItem(TOKEN_KEY)) {
        token = sessionStorage.getItem(TOKEN_KEY) ? sessionStorage.getItem(TOKEN_KEY)+"" : "";
    }
    try {
        const response = await fetch(
            `${baseUrl}/job-offer/state`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "sie_token": token
                },
                body: JSON.stringify(bodyRequest)
            }
        )
        return response;
    } catch (error) {
        return error
    }
}
